import React, { useCallback } from 'react';
import { LFC } from '../../Legacy';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { WorkspaceLiteData } from '../../api/ApiTypes';
import { useLoaderOld } from '../../platform/Hook';
import { useResolve } from '../Container';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { TypeaheadInput, TypeaheadItem } from './../../ui';

export type WorkspaceSelectorCallback = (workspaces: WorkspaceLiteData[]) => void;
export const WorkspaceSelector: LFC<{ items: WorkspaceLiteData[], onSelect: WorkspaceSelectorCallback }> = ({ items, onSelect }) => {

    const api = useResolve(ApiClient);
    const [_ready, workspaceList] = useLoaderOld(async () => await api.exec(v2.admin.workspaces.list()));
    const workspaceSource = useCallback((query: string) => {
        const results = workspaceList.filter(x => x.label.toLowerCase().includes(query?.toLowerCase()));
        return (results.length > 0) ? results : [TypeaheadItem('none', 'No workspaces matching this search...', null, true)];
    }, [workspaceList]);

    const onAddWorkspace = useCallback((w: WorkspaceLiteData) => {
        if (!items.find(x => x.id === w.id)) {
            onSelect(items.concat(w));
        }
        return true;
    }, [items, onSelect]);

    const onItemAdd = useCallback((values: any) => {
        values = Array.isArray(values) ? values : [values];
        onSelect([...items, ...values]);
    }, [items, onSelect]);

    const onItemRemove = useCallback((value: any) => {
        onSelect(items.filter(x => x !== value));
    }, [items, onSelect]);

    return <Flexer>
        <TypeaheadInput
            placeholder="e.g. My First Workspace"
            itemMode
            items={items}
            onItemAdd={onItemAdd}
            onItemRemove={onItemRemove}
            typeaheadSource={workspaceSource}
            onTypeaheadSelect={onAddWorkspace}
        />
    </Flexer>;
};
